// Inter's @font-face + preload live inline in public/index.html (spec c.3), so the
// font URL is stable and preloadable. Cascade: tokens → base → layout → components;
// section CSS is imported by its components, admin.css only by the lazy AdminApp.
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/layout.css";
import "./styles/components.css";
import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import App from "./App";
import i18n from "./i18n";

const container = document.getElementById("root")!;
const root = createRoot(container);

// Fallback null: en/es are bundled, so this only shows (nothing) for the few ms
// a stored fr/pt choice takes to load its dictionary chunk.
root.render(
  <Suspense fallback={null}>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </Suspense>
);
